import $ from "jquery";
import {sendPostQuery, showToastNotify, TOASTR_ERROR} from "./helpers";
import {sendAuthPost} from "./auth";
import {confirmAuthCode, needSettingConfirmAuthCode} from "./authConfirm";

const NON_VISIBLE = 'd-none';
let settingCheck = true;

const IPHONE_TYPE = 'iphone',
    ANDROID_TYPE = 'android',
    TOKEN_BOX = $('#bind-token'),
    ERR_FIELD = 'error-input-group',
    EMPTY_TOKEN = $('#token-empty-error')

let AUTH_CODE = '',
    INLINE_URL = '',
    OS_TYPE = ''

const saveSettings = () => {
    const selectedLocale = $("#setting-locale :selected").val();
    const checkType = $("input[name=auth_check_control]:checked").val();

    const url = '/setting-save';
    const data = {
        'locale': selectedLocale,
        'check_type': checkType,
    };
    sendPostQuery(url, true, true, data);
}

const checkPasswordUpdate = (currentPassword, newPassword, repeatPassword) => {
    if (!currentPassword) {
        settingCheck = false;
        $('#setting-current-pass-error').removeClass(NON_VISIBLE)
    }
    if (!newPassword) {
        settingCheck = false;
        $('#setting-new-pass-error').removeClass(NON_VISIBLE)
    }
    if (!repeatPassword) {
        settingCheck = false;
        $('#setting-repeat-pass-error').removeClass(NON_VISIBLE)
    }
    if (newPassword && repeatPassword && newPassword != repeatPassword) {
        settingCheck = false;
        $('#setting-not-match-pass-error').removeClass(NON_VISIBLE)
    }
}

const clearErrorFields = () => {
    settingCheck = true;
    $('#setting-current-pass-error').addClass(NON_VISIBLE)
    $('#setting-new-pass-error').addClass(NON_VISIBLE)
    $('#setting-repeat-pass-error').addClass(NON_VISIBLE)
    $('#setting-not-match-pass-error').addClass(NON_VISIBLE)
}

const changePassword = () => {
    const currentPassword = $('#setting-current-password').val();
    const newPassword = $('#setting-new-password').val();
    const repeatPassword = $('#setting-repeat-password').val();
    checkPasswordUpdate(currentPassword, newPassword, repeatPassword);
    if (settingCheck) {
        const url = '/change-password';
        const data = {
            'current_password': currentPassword,
            'new_password': newPassword,
            'repeat_password': repeatPassword,
        };
        sendPostQuery(url, false, true, data, true, '/sign-in');
    }
}

const enabledGgAuthNext = () => {
    $('#enabledGgAuth').modal('hide');
    ggAuthSetup();
}

const getGGAuthCode = () => {
    let errorMsg = 'Something wrong';
    $.ajax({
        type: 'POST',
        url: '/get-auth-code',
        data: {},
        dataType: "json",
        success: function (result) {
            if (result) {
                if (!result.error && result.code) {
                    AUTH_CODE = result.code;
                    INLINE_URL = result.inlineUrl
                } else {
                    if (result.msg) {
                        errorMsg = result.msg;
                    }
                    showToastNotify(TOASTR_ERROR, '', errorMsg)
                }
            }
        }
    });
}

const ggAuthSetup = () => {
    if (OS_TYPE === IPHONE_TYPE) {
        document.getElementById('authAppLink').setAttribute('href',
            'https://itunes.apple.com/app/google-authenticator/id388497605')
    } else if (OS_TYPE === ANDROID_TYPE) {
        document.getElementById('authAppLink').setAttribute('href',
            'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2')
    } else {
        document.getElementById('authAppLink').setAttribute('href',
            'https://support.google.com/accounts/answer/1066447?hl=en')
    }
    if (AUTH_CODE && INLINE_URL) {
        let QRCode = require('qrcode');
        $('#auth-qr').removeClass(NON_VISIBLE);
        QRCode.toDataURL(INLINE_URL, function (err, url) {
            document.getElementById('gg-auth-qr').setAttribute('src', url);
        })
        $('#auth-secret-code').text(AUTH_CODE)
    }
    $('#ggAuthSetup').modal('show');
}

const openAuthModal = () => {
    $('#ggAuthSetup').modal('hide')
    $('#authModal').modal('show')
}

const checkGgCode = () => {
    const authKey = $('#setting-gg-auth-code').val()
    const data = {
        '2fa_key': authKey
    };

    sendAuthPost('/check-auth-code', false, false,
        data, false, '', null, true, 'ggAuthConnected');
}

const showGgAuthConnected = () => {
    $('#authModal').modal('hide')
    $('#ggAuthConnected').modal('show')
}

const showGgAuth = () => {
    getGGAuthCode();
    $('#enabledGgAuth').modal('show');
}

const disableGgAuth = () => {
    $('#ggAuthSettingActions').modal('hide');
    const needConfirmed = needSettingConfirmAuthCode();
    if (needConfirmed == 1) {
        confirmAuthCode('disableGgAuthQuery');
    } else {
        sendDisableGgAuthQuery();
    }
}

export const sendDisableGgAuthQuery = () => {
    let data = {}
    sendAuthPost('/disable-gg-auth', true, true, data, false, '');
}

const ggAuthConnectedHide = () => {
    $('#ggAuthConnected').on('hidden.bs.modal', function (e) {
        location.reload();
    })
}

const setAndroidType = () => {
    OS_TYPE = ANDROID_TYPE
    const androidIcon = $('#android-icon')
    const appleIcon = $('#apple-icon')
    androidIcon.removeClass('icon-android_grey')
    androidIcon.addClass('icon-android_green')
    $('#android-title').addClass('success-color')
    $('#android-check').removeClass(NON_VISIBLE)
    $('#os-card-android').addClass('os-card-border-green')
    $('#os-card-apple').removeClass('os-card-border-green')
    appleIcon.removeClass('icon-macos_green')
    appleIcon.addClass('icon-macos_grey')
    $('#apple-title').removeClass('success-color')
    $('#apple-check').addClass(NON_VISIBLE)
}

const setAppleType = () => {
    OS_TYPE = IPHONE_TYPE
    const appleIcon = $('#apple-icon')
    const androidIcon = $('#android-icon')
    appleIcon.removeClass('icon-macos_grey')
    appleIcon.addClass('icon-macos_green')
    $('#apple-title').addClass('success-color')
    $('#apple-check').removeClass(NON_VISIBLE)
    $('#os-card-apple').addClass('os-card-border-green')
    $('#os-card-android').removeClass('os-card-border-green')
    androidIcon.removeClass('icon-android_green')
    androidIcon.addClass('icon-android_grey')
    $('#android-title').removeClass('success-color')
    $('#android-check').addClass(NON_VISIBLE)
}

const openGgSetupModal = () => {
    $('#authModal').modal('hide')
    $('#ggAuthSetup').modal('show')
}

const openEnabledGgAuth = () => {
    $('#ggAuthSetup').modal('hide')
    $('#enabledGgAuth').modal('show')
}

const bindAccounts = () => {
    const tokenBox = $('#bind-token')
    const token = tokenBox.val();
    if (!token) {
        EMPTY_TOKEN.removeClass(NON_VISIBLE)
        tokenBox.addClass(ERR_FIELD)
    } else {
        EMPTY_TOKEN.addClass(NON_VISIBLE)
        const data = {
            'token': token
        };
        sendPostQuery('/bind-accounts', false, true, data, false, '',
            true, 'botConnected');
    }
}

function clearTokenErr() {
    TOKEN_BOX.removeClass(ERR_FIELD)
    EMPTY_TOKEN.addClass(NON_VISIBLE)
}

function botConnectedSubmit() {
    window.setTimeout(function () {
        location.reload()
    }, 1000);
}

function disableAccountSync() {
    sendPostQuery('/disable-sync', false, true, {}, false, '',
        true, 'disableBotSync');
}

function authPage() {
    location.href = '/sign-in';
}

function showAuthSettingActions() {
    $('#ggAuthSettingActions').modal('show');
}

function showSecretCode(secret, url) {
    let QRCode = require('qrcode');
    $('#auth-qr-settings').removeClass(NON_VISIBLE);
    QRCode.toDataURL(url, function (err, url) {
        document.getElementById('gg-auth-qr-code').setAttribute('src', url);
    })
    $('#gg-auth-secret-code').text(secret)
    $('#showAuthSecret').modal('show');
}

function showAuthSecret() {
    $('#ggAuthSettingActions').modal('hide');
    const needConfirmed = needSettingConfirmAuthCode();
    if (needConfirmed == 1) {
        confirmAuthCode('secretGgAuthCode');
    } else {
        getAuthSecretCode();
    }
}

export function getAuthSecretCode() {
    return $.ajax({
        type: 'POST',
        url: '/gg-secret-code',
        data: {},
        success: function (result) {
            let message = 'Something wrong';
            if (result) {
                if (result.msg) {
                    message = result.msg
                }
                if (!result.error && result.secret) {
                    showSecretCode(result.secret, result.url)
                } else {
                    showToastNotify(TOASTR_ERROR, '', message);
                }
            }
        }
    });
}

const ggAuthSecretModalHide = () => {
    $('#showAuthSecret').on('hidden.bs.modal', function (e) {
        location.reload()
    })
}

$(document).ready(() => {
    ggAuthConnectedHide();
    ggAuthSecretModalHide();
})

window.saveSettings = saveSettings;
window.changePassword = changePassword;
window.clearErrorFields = clearErrorFields;
window.enabledGgAuthNext = enabledGgAuthNext;
window.openAuthModal = openAuthModal;
window.showGgAuth = showGgAuth;
window.checkGgCode = checkGgCode;
window.disableGgAuth = disableGgAuth;
window.setAndroidType = setAndroidType;
window.setAppleType = setAppleType;
window.openGgSetupModal = openGgSetupModal;
window.openEnabledGgAuth = openEnabledGgAuth;
window.bindAccounts = bindAccounts;
window.clearTokenErr = clearTokenErr;
window.botConnectedSubmit = botConnectedSubmit;
window.disableAccountSync = disableAccountSync;
window.authPage = authPage;
window.showAuthSettingActions = showAuthSettingActions;
window.showAuthSecret = showAuthSecret;

export default {
    sendDisableGgAuthQuery, getAuthSecretCode
}

